import { string } from "yup";
import API from "../../config/api";
import { serializeQueryParams } from "../../config/apiutlils";
import config from "../../config/config";
import { Success } from "../../context/notify";
import { BlogDetailsParams, BlogParams } from "../../Typings/dataListing";
import { dataActionTypes } from "../constants/ActionTypes";

export const getContactList = (defaultparams: any,callBack?: any) => async (dispatch: any) => {
    let path = "api/Contacts/GetContactList";
    await API().get(path,{
        params: defaultparams,
    }).then((response: any) => {
        if (response.status === 200 && callBack) {
            callBack(response.data);
        }
    }).catch((err) => { 
        callBack(err); 
    });
}

export const getContactById = (payload: any, handleNext?: any) => async (dispatch: any) => {
    var path = "api/Contacts/GetById"
    await API().get(path, {
        params: payload,
    }).then((response: any) => {
        if (response.status === 200 && handleNext) {
            handleNext(response.data);
        }
    }).catch((err) => {
        handleNext(err);
    });

};

export const UpdateContactById = (defaultparams: any, callBack?: any) => async (dispatch: any) => {
    var path = "api/Contacts/UpdateContact";
    await API().patch(path, defaultparams).then((response: any) => {
        if (response.status === 200 && callBack) {
            callBack(response.data);
        }
    }).catch((err) => {
        callBack(err);
    });
}

export const AddContactsData = (defaultparams: any, callBack?: any) => async (dispatch: any) => {
    var path = "api/Contacts/AddContact";
    await API().post(path, defaultparams).then((response: any) => {
        if (response.status === 200 && callBack) {
            callBack(response.data);
        }
    }).catch((err) => {
        callBack(err);
    });
}

